import { Card, CardContent } from "components/ui/card";
import { GetList } from "types/data-content";

interface IServicePage {
  pageData: GetList;
}

const ProcessSection = ({pageData}: IServicePage) => {
  return (
    <section className="pb-8 sm:pb-16 px-6 bg-muted/30">
      <div className="container mx-auto px-4 sm:max-w-5xl">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-4 text-foreground">
          {pageData?.processTitle}
        </h2>
        <div className="grid md:grid-cols-2 gap-6">
          {pageData?.processMarketing?.map((item, index) => {
            const Icon = item.icon;
            return (
              <Card 
                key={index}
                className="border-none shadow-md hover:shadow-card-hover transition-all duration-300"
              >
                <CardContent className="flex items-center gap-4 p-6">
                  <div className="h-12 w-12 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
                    <Icon className="h-6 w-6 text-primary-foreground" />
                  </div>
                  <p className="text-lg font-medium">{item.title}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
